import {useTranslation} from 'react-i18next';
import * as css from './PermissionBanner.css';
import Lock from '../../../assets/icons/Lock';

interface PermissionBannerProps {
    permissions: string[];
}

function PermissionBanner({permissions}: PermissionBannerProps) {
    const {t} = useTranslation('layout');
    
    if (!permissions || permissions.length === 0) {
        return null;
    }
    
    const permissionText = permissions.map(p=>p.split(',').map(per => `{${t(per)}}`).join(' / ')).join(' / ');

    return (
        <css.container>
            <Lock />
            <span>{t('permissionsDesc')}- {permissionText}</span>
        </css.container>
    );
}

export default PermissionBanner;
